import React from 'react';

const RebateTierInput = ({ tier, index, onUpdate, onRemove, tiers }) => {
    const validateTarget = (value) => {
        if (value === '') return true;
        const numValue = Number(value);

        // Check previous tier (if exists)
        if (index > 0 && numValue <= tiers[index - 1].target) {
            alert(`Target must be higher than previous tier (£${tiers[index - 1].target})`);
            return false;
        }

        // Check next tier (if exists)
        if (index < tiers.length - 1 && numValue >= tiers[index + 1].target) {
            alert(`Target must be lower than next tier (£${tiers[index + 1].target})`);
            return false;
        }

        return true;
    };

    return (
        <div className="flex items-center gap-4 mb-2">
            <div className="flex flex-col">
                <label className="text-xs text-gray-600">Target (£)</label>
                <input
                    type="number"
                    min="0"
                    step="1"
                    value={tier.target === 0 ? '' : tier.target}
                    onChange={(e) => {
                        const value = e.target.value === '' ? '' : Number(e.target.value);
                        onUpdate(index, { ...tier, target: value });
                    }}
                    onBlur={(e) => {
                        const value = e.target.value;
                        if (value && !validateTarget(value)) {
                            // Reset to previous valid value or empty
                            onUpdate(index, { ...tier, target: '' });
                        }
                    }}
                    className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Target amount"
                />
            </div>

            <div className="flex flex-col">
                <label className="text-xs text-gray-600">Percentage (%)</label>
                <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={tier.percent === 0 ? '' : tier.percent}
                    onChange={(e) => {
                        const value = e.target.value === '' ? '' : Number(e.target.value);
                        onUpdate(index, { ...tier, percent: value });
                    }}
                    onBlur={() => {
                        // Validate target when percentage is entered
                        if (tier.target && !validateTarget(tier.target)) {
                            onUpdate(index, { ...tier, target: '' });
                        }
                    }}
                    className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Percentage"
                />
            </div>

            <button
                onClick={() => onRemove(index)}
                className="px-2 py-1 text-red-600 hover:text-red-800 mt-5"
            >
                Remove
            </button>
        </div>
    );
};

export default RebateTierInput;